<template>
  <v-card
    class="mx-auto rounded-card"
  >
    <v-list>
      <template
        v-for="(item, index) in items"
      >
        <!-- ヘッダタイトル -->
        <v-subheader
          v-if="item.header"
          :key="item.header"
          v-text="item.header"
        />
        <!-- /ヘッダタイトル -->
        <v-divider
          v-else-if="item.divider"
          :key="index"
          :inset="item.inset"
        />
        <v-list-item
          v-else
          :key="item.title"
          :href="item.href"
          link
        >
          <v-list-item-avatar>
            <v-img
              max-height="90"
              max-width="90"
              contain
              :src="require(`@/assets/images/manual_menu.png`)"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
              v-html="item.title"
            />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>

// import isMobile from 'ismobilejs'
export default {
  name: 'DriverAppMenuIndex',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      items: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.items = this.buildItems()
  },
  methods: {
    /**
     * メニューの生成
     * @return {Array}
     */
    buildItems () {
      const manualUrl = process.env.VUE_APP_STATION_APP_MANUAL_URL
      // const navigator = window.navigator
      // if (isMobile(navigator).apple.device) {
      //   manualUrl = process.env.VUE_APP_STATION_IOS_MANUAL_URL
      // } else if (isMobile(navigator).android.device || isMobile(navigator).amazon.device) {
      //   manualUrl = process.env.VUE_APP_STATION_ANDROID_MANUAL_URL
      // } else {
      //   manualUrl = process.env.VUE_APP_STATION_IOS_MANUAL_URL
      // }
      return [
        {
          header: 'その他メニュー'
        },
        {
          icon: 'mdi-message-question-outline',
          title: 'オンラインマニュアル',
          subtitle: '',
          href: manualUrl
        },
        // { divider: true, inset: true },
        // {
        //   icon: 'mdi-book-open-variant',
        //   title: '確認',
        //   subtitle: '',
        //   href: 'https://www.cman.jp/network/support/go_access.cgi'
        // }
        // { divider: true, inset: true },
      ]



    }

  }
}
</script>

<style scoped lang="scss">

</style>
